<div class="dialog">
  @if (loading()) {
    <div class="loading-overlay">
      <mat-progress-spinner mode="indeterminate" diameter="40" />
    </div>
  }

  <div class="dialog__header">
    <h2>{{ 'staff.edit.title' | translate }}</h2>
    <button class="dialog__header-close" type="button" (click)="onCancel()" aria-label="Close">
      <app-icon [icon]="IconName.CLOSE" />
    </button>
  </div>

  @if (form) {
    <form class="form" [formGroup]="form" (ngSubmit)="onSave()">
      <div class="form-fields">
        <div class="field">
          <mat-label>{{ 'staff.edit.firstName' | translate }}</mat-label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="firstName" type="text" />
            @if (getErrorMessageForStaff('firstName')) {
              <mat-error>
                {{ getErrorMessageForStaff('firstName') | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field">
          <mat-label>{{ 'staff.edit.lastName' | translate }}</mat-label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="lastName" type="text" />
            @if (getErrorMessageForStaff('lastName')) {
              <mat-error>
                {{ getErrorMessageForStaff('lastName') | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field">
          <mat-label>{{ 'staff.edit.email' | translate }}</mat-label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="email" type="email" />
            @if (getErrorMessageForStaff('email')) {
              <mat-error>
                {{ getErrorMessageForStaff('email') | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="field">
          <mat-label>{{ 'staff.edit.role' | translate }}</mat-label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="role">
              @for (r of roles; track r.id) {
                <mat-option [value]="r.name">
                  {{ r.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="reset-password-cont">
        <h4>{{ 'staff.edit.resetPasswordTitle' | translate }}</h4>
        <div class="reset-password-bottom">
          <div class="reset-password-date">
            {{ 'staff.edit.passwordUpdateTime' | translate }}
            <span class="actual-date">
              {{ passwordUpdateDate() | date: 'yyyy-MM-dd HH:mm:ss' }}
            </span>
          </div>
          <div class="reset-password-btn-cont">
            <button
              type="button"
              class="btn-reset-password"
              [disabled]="isResettingPassword()"
              (click)="resetPassword()"
            >
              {{ 'staff.edit.resetPasswordBtn' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="activate-checkbox">
        <mat-slide-toggle [hideIcon]="true">
          {{ 'staff.edit.activated' | translate }}
        </mat-slide-toggle>
      </div>

      <div class="form-actions">
        <button type="button" class="btn-delete" (click)="removeStaffMember()">
          {{ 'staff.edit.deleteStaff' | translate }}
        </button>
        <div class="right-buttons">
          <button type="button" class="btn-cancel" (click)="onCancel()">
            {{ 'staff.edit.cancel' | translate }}
          </button>
          <button type="submit" class="btn-save" [disabled]="loading()">
            {{ 'staff.edit.save' | translate }}
          </button>
        </div>
      </div>
    </form>
  }
</div>
